import dayjs from 'dayjs';
import storeCodeDictionary from '../store/store_codeDictionary';

const ReviewScorePlugin = {};
const CODE_DICTIONARY = storeCodeDictionary.state;

ReviewScorePlugin.install = function (Vue) {

    Vue.prototype.$_getTotalReview = function(good, normal, bad) {
        let result = 0;
        
        if( ![good, normal, bad].includes(undefined) )
            result = good + normal + bad;
        
        return result;
    }

    Vue.prototype.$_getRateGood = function(good, normal, bad) {
        let result = 0;
        let total = this.$_getTotalReview(good, normal, bad);

        if(total)
            result = this.$_toFixed(good / total * 100);

        return result;
    }

    Vue.prototype.$_getRateNormal = function(good, normal, bad) {
        let result = 0;
        let total = this.$_getTotalReview(good, normal, bad);

        if(total)
            result = this.$_toFixed(normal / total * 100);

        return result;
    }

    Vue.prototype.$_getRateBad = function(good, normal, bad) {
        let result = 0;
        let total = this.$_getTotalReview(good, normal, bad);

        if(total)
            result = this.$_toFixed(bad / total * 100);

        return result;
    }

    Vue.prototype.$_getRankingList = function(items = []) {
        let detailType = ["A","B","C","D","E","F"];
        let detailScore = [];
        let result = [];

        items.forEach( (item, idx) => {
            detailScore.push({ type: detailType[idx], count: item ? item : 0 })
        })

        for(let i=0 ; i<detailScore.length ; i++) {

            for(let j=i ; j<detailScore.length ; j++) {
                let temp = {};

                if(detailScore[i].count < detailScore[j].count) {
                    temp = detailScore[i];
                    detailScore[i] = detailScore[j];
                    detailScore[j] = temp;
                }
            }
        }
        
        result = detailScore;

        return result;
    }

    Vue.prototype.$_getScCareer = function(careers=[], joinDt="") {
        let items = careers;
        let start, end, result; //diff,
        let careerMonth = 0;

        careerMonth += dayjs().diff(joinDt, "month");

        items.forEach( (item) => {
            start = dayjs(item.startDt);
            end = dayjs(item.endDt);

            careerMonth += end.diff(start, "month");
            // diff = end.diff(start, "month", true);

            // careerMonth += this.$_toFixed(diff, 0);
        })

        result = this.$_mathCareer(careerMonth);
        
        return result+"년";
    }

    Vue.prototype.$_getScCareerByMonth = function(career=0) {
        let result = 0;
        let careerMonth = career;

        result = this.$_mathCareer(careerMonth);

        return result+"년";
    }

    Vue.prototype.$_getCodeDicData = function(id="", get="title") {
        const DICTIONARY = CODE_DICTIONARY.items;
        let result = {};

        if(id=="")
            return "";

        for(let key in DICTIONARY)
        {
            for(let subkey in DICTIONARY[key])
            {
                if(DICTIONARY[key][subkey].id == id)
                {
                    result = DICTIONARY[key][subkey];
                }
            }
        }
        
        return result[get];
    }

    Vue.prototype.$_clearStatsDatas = function() {
        this.$store.commit('CLEAR_REVIEW');
        this.$store.commit('CLEAR_REVIEW_LIST');
        this.$store.commit('CLEAR_SC');
        this.$store.commit('CLEAR_SC_LIST');
        this.$store.commit('CLEAR_SHOP');
        this.$store.commit('CLEAR_SHOP_LIST');
        this.$store.commit('CLEAR_TRIM');
        this.$store.commit('CLEAR_TRIM_LIST');
        this.authBookingAlarmCheck();
        this.$store.commit('SET_TRANSITION_NAME_SLIDE_LEFT')
    }

    // Vue.prototype.$_callbackAppCurrentLocation = function(lat, har) {
    //     this.$store.state.currentLocationLat = lat;
    //     this.$store.state.currentLocationHar = har;
    // }

    Vue.prototype.$_appPopupMessage = function(msg) {
        this.$store.commit('OPEN_MODAL', {
            title:'안내',
            content: msg,
            btnOne: '확인',
        });
    }
}

export default ReviewScorePlugin;